import {Component, ContentChild, ElementRef, EventEmitter, OnInit, Output} from '@angular/core';
import {ViewModeDirective} from './view-mode.directive';
import {EditModeDirective} from './edit-mode.directive';
import {fromEvent, Subject} from 'rxjs';
import {filter, switchMapTo, take} from 'rxjs/operators';
import {Compbaser} from "../compbaser";
import {restrictSingleQuote} from "../../common";

@Component({
    selector: 'editable',
    styleUrls: ['./editable.component.css'],
    template: `
        <span inputrestriction="basic0" (keypress)="onKeyup($event)" class="editable-input">
            <ng-container *ngTemplateOutlet="currentView"></ng-container>
        </span>
    `
})
export class EditableComponent extends Compbaser implements OnInit {
    @ContentChild(ViewModeDirective, {static: true}) viewModeTpl: ViewModeDirective;
    @ContentChild(EditModeDirective, {static: true}) editModeTpl: EditModeDirective;
    @ContentChild('editInput') child: ElementRef;
    @Output() update = new EventEmitter();

    editMode = new Subject();
    editMode$ = this.editMode.asObservable();

    mode: 'view' | 'edit' = 'view';


    constructor(private host: ElementRef) {
        super();
    }

    ngOnInit() {
        this.viewModeHandler();
        this.editModeHandler();
    }

    onKeyup(e) {
        if (e.key !== 'Enter') return;
        this.toViewMode();
    }

    toViewMode() {
        let value = this.child ? this.child.nativeElement.value : null;
        if (value === null) return;
        value = restrictSingleQuote(value);
        this.update.next(value);
        this.mode = 'view';
    }

    private get element() {
        return this.host.nativeElement;
    }

    private viewModeHandler() {
        this.cod(
            fromEvent(this.element, 'click').pipe(
            ).subscribe(() => {
                this.mode = 'edit';
                this.editMode.next(true);
            })
        );
    }

    private editModeHandler() {
        const clickOutside$ = fromEvent(document, 'click').pipe(
            filter(({target}) => (this.element.contains(target) === false || target['className'].indexOf('mat-icon') > -1)),
            take(1)
        );

        this.cod(
            this.editMode$.pipe(
                switchMapTo(clickOutside$),
            ).subscribe(event => this.toViewMode())
        );
    }

    get currentView() {
        return this.mode === 'view' ? this.viewModeTpl.tpl : this.editModeTpl.tpl;
    }
}
